import Http, {UrlFull} from '../Http';

export const saveInfo = data =>
  Http.post(UrlFull + 'api/docs/solicitud', {
    doc_documento_solicitud: [data],
  });

export const saveFile = (idSol, base64Files) => {
  // Extraer todos los archivos de los distintos inputId
  const documentos = Object.values(base64Files)
    .flatMap(input => input.base64Files) // Extrae los archivos dentro de cada inputId
    .map(file => ({
      id: idSol, // id de la solicitud
      codigo: file.codigo, // Usa el código del archivo
      nombre: file.descripcion,
      descripcion: file.descripcion, // Usa la descripción del archivo
      esPrincipal: 0,
      base64: file.base64, // Usa el base64 del archivo
    }));

  return Http.post(UrlFull + 'api/util/adjunto', {
    doc_documento_solicitud: documentos,
  });
};
